export default "__VITE_ASSET__Dr4Yv4vo__"